import { render, staticRenderFns } from "./BannerTwo.vue?vue&type=template&id=5731b959&"
import script from "./BannerTwo.vue?vue&type=script&lang=js&"
export * from "./BannerTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports